// src/app/_services/language-direction.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class LanguageDirectionService {
    private directionMap: { [key: string]: string } = {
        en: 'ltr',
        fr: 'ltr',
        es: 'ltr',
        pt: 'ltr',
        ko: 'ltr',
        ar: 'rtl',
        he: 'rtl',
    };

    private directionSubject = new BehaviorSubject<string>('ltr');
    direction$: Observable<string> = this.directionSubject.asObservable();

    setLanguage(lang: string) {
      const direction = this.directionMap[lang] || 'ltr';
        this.directionSubject.next(direction);
    }

    getCurrentDirection(): string {
        return this.directionSubject.getValue();
    }
}



// WEBPACK FOOTER //
// ./src/app/_services/language-direction.service.ts